import { render, staticRenderFns } from "./parent-view.vue?vue&type=template&id=52a4516a"
import script from "./parent-view.vue?vue&type=script&lang=js"
export * from "./parent-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports